import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {PatronBalanceTransaction} from '@store/balance/balance.types';
import {BalanceSelectors} from '@store/balance/balance.selectors';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'px-expanded-transaction-amounts',
  host: {
    class: 'text-body-medium md:text-body-small'
  },
  template: `
    @for (balanceLine of transactionSelectors.sortedBalanceLinesFor(transaction) | select; track balanceLine.id) {
      <div mxTruncate class="text-right md:text-left">
        {{ transactionLineSelectors.amountFor(balanceLine) | select | format:'CURRENCY' }}
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe, SelectPipe, TruncateDirective]
})
export class ExpandedTransactionAmountsComponent {
  @Input({required: true}) transaction: PatronBalanceTransaction;
  public readonly transactionSelectors = BalanceSelectors.BalanceTransactions;
  public readonly transactionLineSelectors = BalanceSelectors.BalanceTransactionLines;
}
